module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Angle-double-down-d49c32ac0e7fb29fe5862f1f8b6142d9.svg";